export default __webpack_public_path__ + "static/media/pin.0dcc96b8.png";